"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hearingSectionsContract = exports.GetHearingSectionsQueryParams = exports.GetHearingHearingSectionsQueryParamsSchema = exports.GetAudioSegmentHearingSectionsQueryParamsSchema = exports.GetRecordingHearingSectionsQueryParamsSchema = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@ts-rest/core");
const zod_1 = tslib_1.__importDefault(require("zod"));
const resources_1 = require("./resources");
const refine_1 = require("./util/refine");
const c = (0, core_1.initContract)();
const GetHearingSectionsQueryParamsBaseSchema = zod_1.default.object({
    courtSystemId: zod_1.default.string().uuid(),
});
exports.GetRecordingHearingSectionsQueryParamsSchema = GetHearingSectionsQueryParamsBaseSchema.merge(zod_1.default.object({ recordingId: zod_1.default.string().uuid() })).strict();
exports.GetAudioSegmentHearingSectionsQueryParamsSchema = GetHearingSectionsQueryParamsBaseSchema.merge(zod_1.default.object({ audioSegmentId: zod_1.default.string().uuid() })).strict();
exports.GetHearingHearingSectionsQueryParamsSchema = GetHearingSectionsQueryParamsBaseSchema.merge(zod_1.default.object({ hearingId: zod_1.default.string().uuid() })).strict();
const GetHearingSectionsQueryParamsSchema = zod_1.default
    .union([
    exports.GetRecordingHearingSectionsQueryParamsSchema,
    exports.GetAudioSegmentHearingSectionsQueryParamsSchema,
    exports.GetHearingHearingSectionsQueryParamsSchema,
])
    .transform(value => {
    if ('recordingId' in value) {
        return { ...value, type: 'recording' };
    }
    if ('audioSegmentId' in value) {
        return { ...value, type: 'audio-segment' };
    }
    if ('hearingId' in value) {
        return { ...value, type: 'hearing' };
    }
    return value;
});
exports.GetHearingSectionsQueryParams = GetHearingSectionsQueryParamsSchema.refine((refine_1.is));
const path = '/hearing-sections';
exports.hearingSectionsContract = c.router({
    getHearingSections: {
        method: 'GET',
        path,
        headers: resources_1.UserOrApiAuthHeadersSchema,
        responses: {
            [200]: zod_1.default.array(resources_1.HearingSection),
            [400]: resources_1.ErrorResponse,
            [401]: resources_1.ErrorResponse,
            [403]: resources_1.ErrorResponse,
        },
        query: exports.GetHearingSectionsQueryParams,
        summary: 'Retrieve hearing sections for a hearing, recording or audio segment',
    },
    checkHearingSectionAccess: {
        method: 'GET',
        path: `${path}/check-access`,
        headers: resources_1.UserAuthHeadersSchema,
        responses: {
            [204]: zod_1.default.undefined(),
            [400]: resources_1.ErrorResponse,
            [401]: resources_1.ErrorResponse,
            [403]: resources_1.ErrorResponse,
        },
        query: exports.GetHearingSectionsQueryParams,
        summary: 'Check access to hearing sections for a hearing, recording or audio segment',
    },
}, {
    strictStatusCodes: true,
    validateResponseOnClient: true,
});
